import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { AppConfig } from 'src/app/app.config';
import { ChartService } from 'src/app/services/chart.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  statisticData: any;

  constructor(
    public authService: AuthService,
    public chartService: ChartService,
    private config: AppConfig,
  ) { 

    this.refreshData();

  }

  ngOnInit() {
  }


   refreshData() {

    setTimeout(() => {

      this.chartService.getHomeStatistics().subscribe((data: any)=>{
      this.statisticData = data;
    }) 

    }, 3000);

  }

  logout() {
    this.authService.Logout()
      .subscribe(
        data => {
          localStorage.removeItem('UserData');
          localStorage.removeItem(this.config.JWT_Token);
          localStorage.removeItem(this.config.Session_User);
          localStorage.removeItem(this.config.valide_User);

          // this.router.navigate(['../auth/login']);
        },
        error => {
          if (error.status === 404) {
            localStorage.removeItem(this.config.JWT_Token);
            localStorage.removeItem(this.config.Session_User);
            localStorage.removeItem(this.config.valide_User);

            // this.router.navigate(['../welcome']);

          } else {
            console.log(error + '');
          }

        }
      );
      localStorage.clear();

      // this.router.navigate(['../auth/login']);



  }

  closePopup() {
    
  }
  closeApprovalSetting() {

  }
  removeEmployeeConfirmation() {

  }
 


}
